import "./AssetLocation.scss"
import IconMobile from "assets/img/icon-mobile-sm.svg?react"
import IconDesktop from "assets/img/icon-desktop-sm.svg?react"
import markerDefault from "assets/img/map-marker-default.svg"

import { FC, MouseEvent } from "react"
import { useTranslation } from "react-i18next"
import cn from "classnames"

import AssetLocationModel from "models/AssetLocation"
import { Grid, GridItem } from "components/Grid"
import Checkbox from "components/Checkbox/Checkbox"
import { Flex } from "components/Flex"
import FlexibleContent from "components/FlexibleContent/FlexibleContent"
import AssetStoredStatus from "components/AssetStoredStatus/AssetStoredStatus"
import { LocationSource } from "models/Location"
import Tooltip from "components/Tooltip/Tooltip"
import MapMarkerTracking from "components/MapView/MapMarker/MapMarkerTracking"

interface IAssetLocationProps {
    assetLocation: AssetLocationModel
    number?: number
    selected: boolean
    onToggleSelection: () => void
    onMarkerClick: () => void
}

const AssetLocation: FC<IAssetLocationProps> = ({
    assetLocation,
    number,
    selected,
    onToggleSelection,
    onMarkerClick,
}) => {
    const { t } = useTranslation()

    function handleMarkerClick(e: MouseEvent) {
        e.stopPropagation()
        onMarkerClick()
    }

    return (
        <Grid
            columns="max-content minmax(0, auto) max-content"
            gap="1.6rem"
            className={cn("asset-location p-3", { "bg-grey-50": selected })}
            onClick={onToggleSelection}>
            <GridItem className="pt-half">
                <Checkbox
                    checked={selected}
                    onChange={onToggleSelection}
                />
            </GridItem>
            <Flex flow="column" gap=".4rem">
                {!!assetLocation.locatingTime &&
                    <FlexibleContent
                        text={assetLocation.locatingTime.format(t('config.dateLongTimeFormat'))}
                        className="color-grey-500"
                    />
                }
                {!!assetLocation.createdByEmail &&
                    <FlexibleContent
                        text={assetLocation.createdByEmail}
                        className="font-bold"
                    />
                }
                {(!!assetLocation.stateOfStorage || !!assetLocation.source) &&
                    <Flex alignItems="center" gap=".4rem">
                        {!!assetLocation.stateOfStorage &&
                            <AssetStoredStatus status={assetLocation.stateOfStorage} />
                        }
                        {!!assetLocation.source &&
                            <>
                                {assetLocation.source === LocationSource.mobile && <IconMobile width={16} height={16} />}
                                {assetLocation.source === LocationSource.web && <IconDesktop width={16} height={16} />}
                            </>
                        }
                    </Flex>
                }
            </Flex>
            <GridItem>
                {number
                    ? <Tooltip trigger="hover"
                        content={t('asset.pastLocation')}>
                        <MapMarkerTracking number={number} onClick={handleMarkerClick} />
                    </Tooltip>
                    : <Tooltip trigger="hover"
                        content={t('asset.currentLocation')}>
                        <img src={markerDefault} alt="" onClick={handleMarkerClick} />
                    </Tooltip>
                }
            </GridItem>
        </Grid>
    )
}

export default AssetLocation
